module.exports = __webpack_public_path__ + "static/media/askVeterinary.d4d9c2c0.png";